import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import RMFAddress from '../components/RMFAddress/RMFAddress';
import RMFBankDetails from '../components/RMFBankDetails/RMFBankDetails';
import RMFDOB from '../components/RMFDOB/RMFDOB';
import RMFGender from '../components/RMFGender/RMFGender';
import RMFIdentityVerification from '../components/RMFIdentityVerification/RMFIdentityVerification';
import RMFLegalName from '../components/RMFLegalName/RMFLegalName';
import RMFTermsOfService from '../components/RMFTermsOfService/RMFTermsOfService';

import useRMFBaseSteps from './useRMFBaseSteps';
import { Guard } from './useRmfGuards';
import { Service } from './useRmfServices';

const useRmfPTFlow = (): FlowConfig => {
  const { jumpToFeatureStep, forkJumpToFeature, forkRmfExit, invokeLegalNameSave } =
    useRMFBaseSteps();

  const invokeRmfDobUpdate = new Invoke(Service.RmfDobUpdate, RMFGender, RMFDOB);

  const forkDobCheck = new Fork(Guard.RmfDobEnabled, [RMFDOB, invokeRmfDobUpdate], [RMFGender]);
  const invokeSignupDob = new Invoke(Service.SignupDobFetch, forkDobCheck);

  const invokeEnableRealMoneyFlag = new Invoke(
    Service.RmfEnableRealMoneyFlag,
    forkJumpToFeature,
    RMFTermsOfService
  );

  const invokeUpdateBankDetails = new Invoke(
    Service.RmfUpdateBankDetailsInfo,
    invokeEnableRealMoneyFlag,
    RMFTermsOfService
  );

  const invokeGetBankDetails = new Invoke(Service.RmfGetBankDetailsInfo, RMFBankDetails);
  const invokeGenderSave = new Invoke(Service.RmfGenderSave, RMFAddress, RMFGender);
  const invokeAddressSave = new Invoke(Service.RmfAddressSave, RMFIdentityVerification, RMFAddress);

  const invokeIdentityVerificationSave = new Invoke(
    Service.RmfIdentifyVerificationSavePT,
    invokeGetBankDetails,
    RMFIdentityVerification
  );

  return [
    RMFLegalName,
    invokeLegalNameSave,
    invokeSignupDob,
    forkDobCheck,
    RMFGender,
    invokeGenderSave,
    RMFAddress,
    invokeAddressSave,
    RMFIdentityVerification,
    invokeIdentityVerificationSave,
    invokeGetBankDetails,
    RMFBankDetails,
    RMFTermsOfService,
    invokeUpdateBankDetails,
    invokeEnableRealMoneyFlag,
    forkRmfExit,
    jumpToFeatureStep
  ];
};

export default useRmfPTFlow;
